module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 281);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var _assets_js_utils_use_pwa_signature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15);
/* harmony import */ var _assets_js_utils_log_tracking_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17);
/**
 * @author kyol
 * @description： 代码设计，手写响应式猜源码
 */


global.auxiliaryVars = global.auxiliaryVars || {
  onloaded: false,
  watchProperties: {}
};
// eslint-disable-next-line no-multi-assign
const {
  auxiliaryVars
} = global;
const awaitListName = String.fromCharCode.apply(null, [81, 117, 101, 117, 101]);
const preFix = String.fromCharCode.apply(null, [117, 115, 101]);
const [preFc, Pipe, append] = ["com", "Pipe", "pose"];
// this is use auxiliary tools
class ObserverData {
  constructor(value) {
    this.value = value;
  }
  toString() {
    return this.value;
  }

  // eslint-disable-next-line class-methods-use-this
  toOrigin() {
    return auxiliaryVars.watchProperties;
  }

  // eslint-disable-next-line class-methods-use-this
  [Symbol.toStringTag]() {
    return "ObserverEffect";
  }
}
const useCacheHooks = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "localStorage";
  return (key, hook) => {
    let value = "";
    const saveType = window[type];
    if (Reflect.has(saveType, key)) {
      value = JSON.parse(saveType.getItem(key));
    } else {
      value = typeof hook !== "function" ? hook : hook();
      saveType.setItem(key, JSON.stringify(value));
    }
    return new Proxy(new ObserverData(value), {
      get(origin, keyName) {
        return Reflect.get(origin, keyName);
      },
      set(origin, keyName, val) {
        if (val === null) {
          saveType.removeItem(key);
        } else {
          saveType.setItem(key, JSON.stringify(val));
        }
        return Reflect.set(origin, keyName, val);
      }
    });
  };
};

/**
 *
 * @param {String} keyName
 * @param {any} definePayload
 * @param {Boolean} isRef  : 是不是ref对象，真是ref,false 为reactive
 * @returns ProxyObserver
 */

const useEffect = function () {
  let isRef = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (keyName, definePayload) {
    let {
      reset = false,
      ref
    } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // 构造器
    const seDefval = typeof definePayload === "function" ? definePayload() : definePayload;
    if (!auxiliaryVars.watchProperties[keyName]) {
      auxiliaryVars.watchProperties[keyName] = ref ? ref(seDefval) : new ObserverData(seDefval);
    }
    if (reset) auxiliaryVars.watchProperties[keyName].value = seDefval;
    // 拦截器
    return new Proxy(auxiliaryVars.watchProperties[keyName], {
      get(origin, key) {
        let value = Reflect.get(origin, key);
        if (typeof Reflect.get(origin, "value") === "object" && !isRef) value = Reflect.get(origin.value, key);
        return value;
      },
      set(origin, key, value) {
        return Reflect.set(origin, key, value);
      }
    });
  };
};
const defineFunction = Function || (() => {});
const defineObject = Object || {};
const mapFuncNames = ["forEach", "map", "some", "every", "filter"];
// 扩展USEhooks
const useObjects = mapFuncNames.reduce((p, funcName) => {
  p[funcName] = (object, currayFactory) => originKeys(object)[funcName](hightFn(currayFactory, object));
  return p;
}, {});
useObjects.find = (object, currayFactory) => {
  const amiKey = originKeys(object).find(hightFn(currayFactory, object));
  return amiKey ? {
    key: amiKey,
    value: object[amiKey]
  } : undefined;
};
useObjects.filter = (object, currayFactory) => {
  const amiKeyList = originKeys(object).filter(hightFn(currayFactory, object));
  return amiKeyList.reduce((p, key) => Object.assign(p, {
    [key]: object[key]
  }), {});
};
const originKeys = defineObject.keys.bind(defineObject);
const hightFn = (transformTask, origin) => key => transformTask(origin[key], key, origin);
const useHooks = {
  [`${preFix}Local`]: useCacheHooks(),
  [`${preFix}Session`]: useCacheHooks("sessionStorage"),
  [`${preFix}Ref`]: useEffect(),
  [`${preFix}Reactive`]: useEffect(false),
  [`${preFix}Watch`]: function (watchTask) {
    let watchProNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    const keys = typeof watchProNames === "string" ? [watchProNames] : watchProNames;
    const symbolName = Symbol(keys);
    auxiliaryVars.watchEffects[symbolName] = watchTask;
    return symbolName;
  },
  delRef: keyName => {
    return Reflect.defineProperty(auxiliaryVars.watchProperties, keyName);
  },
  isRef: instance => defineObject.prototype.toString().call(instance).slice(8, -1) === "ObserverData",
  [`${preFc}${append}`]: function () {
    for (var _len = arguments.length, warrior = new Array(_len), _key = 0; _key < _len; _key++) {
      warrior[_key] = arguments[_key];
    }
    return function () {
      const unFunc = warrior.findIndex(f => typeof f !== "function");
      // eslint-disable-next-line no-bitwise
      if (~unFunc) return new Error(`${unFunc}坐标参数必须是函数,${warrior[unFunc]}`);
      for (var _len2 = arguments.length, intor = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        intor[_key2] = arguments[_key2];
      }
      return warrior.reduceRight((h, f, i) => warrior.length === i + 1 ? f(...h) : f(h), intor);
    };
  },
  [`${preFix}Memo`]: (cacheValue, cacheReslut) => function (nextValue, task) {
    const curResult = typeof nextValue === "function" ? nextValue() : nextValue;
    if (curResult === cacheValue) return cacheReslut;
    cacheValue = curResult;
    for (var _len3 = arguments.length, list = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      list[_key3 - 2] = arguments[_key3];
    }
    cacheReslut = task(...list);
    return cacheReslut;
  },
  syncToggle: function (data, key, value) {
    let time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 300;
    return new Promise(resolve => {
      const oval = data[key];
      data[key] = value;
      setTimeout(() => {
        data[key] = oval;
        resolve();
      }, time);
    });
  },
  [`${preFix}Toggle`]: function (listValue) {
    let pre = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : listValue[0];
    if (listValue[0] === Boolean) listValue = [true, false];
    let index = listValue.findIndex(v => (typeof pre === "function" ? pre(v) : v) === pre);
    const {
      length
    } = listValue;
    // eslint-disable-next-line no-bitwise
    if (index === length - 1) index = -1;
    pre = listValue[index + 1];
    return listValue[index + 1];
  },
  curryDalay(taskFn) {
    let timer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
    let callback = arguments.length > 2 ? arguments[2] : undefined;
    return function () {
      for (var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        params[_key4] = arguments[_key4];
      }
      if (taskFn.$beDaley) clearTimeout(taskFn.$beDaley);
      return new Promise(resolve => {
        taskFn.$beDaley = setTimeout(_ => {
          var _taskFn$call;
          callback === null || callback === void 0 ? void 0 : callback(taskFn.call(this, ...params));
          resolve(taskFn === null || taskFn === void 0 ? void 0 : (_taskFn$call = taskFn.call) === null || _taskFn$call === void 0 ? void 0 : _taskFn$call.call(taskFn, this, ...params));
          taskFn.$beDaley = undefined;
        }, timer);
      });
    };
  },
  [`${preFix}${Pipe}`]: pipeFn => params => Promise[pipeFn(params) ? "resolve" : "reject"](params),
  [`${preFix}${awaitListName}`](list, size, curryFn) {
    let index = -1;
    let isOver = false;
    const stop = () => {
      isOver = true;
    };
    const next = async () => {
      if (isOver) return;
      index++;
      const data = list[index];
      if (data === undefined) {
        isOver = true;
      } else {
        const _index = index;
        await data();
        curryFn({
          index: _index,
          next,
          stop
        });
      }
    };
    const startArr = list.slice(0, size);
    startArr.forEach(next);
  }
};
const $wj_tools = {
  $ENV: function () {
    const payload = {
      userAgent: "",
      /*
       * 所有key名对应的value
       * value：[ [第一个数组是需要存在的匹配关键字],[第二个数组是需要不匹配上的关键字] ]
       */
      isWeixin: [["MicroMessenger"], ["wxwork"]],
      isWxwork: [["MicroMessenger", "wxwork"]],
      isLark: [["Lark"]],
      // 飞书
      isDingTalk: [["DingTalk"]] // 钉钉
    };

    const state = {};
    // 存储信息数据
    return {
      // 设置Ua的来源信息
      setUserAgent(ua) {
        Reflect.set(payload, "userAgent", ua);
      },
      // 扩展列表私有属性 payload 对象
      $extend(name, value) {
        if (typeof name === "object") {
          Object.assign(payload, name);
        } else {
          payload[name] = value;
        }
      },
      // 查看对应的key 或者全部key
      viewList(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (key && payload.hasOwnProperty(key)) return Reflect.get(payload, key);
        return payload;
      },
      /**
       * @description： 返回判断环境
       * @param {String in keyof payload} name
       * @return {Boolean}
       *
       */
      get(name) {
        var _global, _global$window, _global$window$naviga;
        // 缓存已经读取过的数据
        if (Reflect.has(state, name)) return Reflect.get(state, name);
        if (name === "userAgent") return Reflect.get(payload, name);
        const [inc = [], exc = []] = Reflect.get(payload, name) || [];
        const au = payload.userAgent || ((_global = global) === null || _global === void 0 ? void 0 : (_global$window = _global.window) === null || _global$window === void 0 ? void 0 : (_global$window$naviga = _global$window.navigator) === null || _global$window$naviga === void 0 ? void 0 : _global$window$naviga.userAgent) || "";
        const status = inc.every(s => au.includes(s)) && exc.every(s => !au.includes(s));
        Reflect.set(state, name, status);
        return status;
      },
      // 移除数据中心
      remove(key) {
        Reflect.deleteProperty(payload, key);
      },
      // thunk执行者函数
      defineState() {
        let middlewareThunk = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => ({});
        let keyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "defineState";
        // eslint-disable-next-line no-return-assign
        return this[keyName] = function () {
          return middlewareThunk(...arguments);
        };
      }
    };
  }(),
  // 后续扩展其定义
  defineInit() {},
  /**
   *
   * @param {Object} data , 就是接口对象
   * @description : 获取套餐接口数据，格式化有效数据
   * @returns Object <{
   *               version：: 当前版本
   *               expireTime：有效时间
   *               nextVersion：下一个版本
   *           }>
   * }
   */
  formatUserPackageInfo(data) {
    // 套餐类型
    const versiobnMap = ["free", "advance_version", "enterprise_version", "enterprise_ultimate_version"];
    let [version, expireTime, isTry] = ["free", "", false];
    if (data.package_status) {
      /**
       * advance_version 高级版本
       * enterprise_version 企业版标准版
       * enterprise_ultimate_version'; // 企业旗舰版
       */
      isTry = !!data.package_status.is_trial;
      version = data.package_status.version;
      expireTime = data.package_status.expire_time || "";
    }
    // 免费版本能升级,其他版本只能续费
    const index = versiobnMap.indexOf(version); // 当前版本索引
    const nextVersion = versiobnMap[index === versiobnMap.length - 1 ? versiobnMap.length - 1 : index + 1]; // 下一本版本名称
    return {
      version,
      // 当前版本
      expireTime,
      // 有效时间
      nextVersion,
      // 下一个升级版本  名称
      isTry,
      // 是不是试用版
      isFree: version == "free",
      // 是不是免费版本
      isAdv: version === "advance_version" && !isTry,
      // 是不是高级版
      isEnt: version === "enterprise_version" && !isTry,
      // 是不是企业版
      isUlt: version === "enterprise_ultimate_version" && !isTry,
      // 是不是旗舰版
      freeName: "free",
      advName: "advance_version",
      // 高级版名称
      entName: "enterprise_version",
      ultName: "enterprise_ultimate_version"
    };
  },
  /**
   * 校验格式函数
   */
  checkRules: (() => ({
    // 邮箱校验
    isEmail(value, customExp) {
      const exp = customExp || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return exp === null || exp === void 0 ? void 0 : exp.test(value);
    },
    // 国内座机号
    isLandlinePhone(value, customExp) {
      const exp = customExp || /0\d{2,3}-?\d{7,8}/;
      return exp.test(value);
    },
    // 国内手机号
    isMobile(value) {
      let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 9;
      let customExp = arguments.length > 2 ? arguments[2] : undefined;
      const exp = customExp || new RegExp(`^1[3456789]\\d{${size}}$`);
      return exp.test(value);
    },
    // 纯数字 0 - 9
    isNumber(value) {
      return /^[0-9]+$/.test(value);
    },
    standardTofixed(value) {
      let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      const [int, float] = (String(value) || "").split(".");
      const padEnd = (float || "").slice(0, size).padEnd(size, "0");
      return size === 0 ? int : `${int}.${padEnd}`;
    }
  }))(),
  questionTypeList(expendsData) {
    const types = {
      "2": {
        template: "q-select",
        name: "单选",
        formName: "单选",
        satisName: "单选",
        title: "请选择一个选项",
        option: "选项",
        trackName: "single_select"
      },
      "3": {
        template: "q-select",
        name: "多选",
        formName: "多选",
        satisName: "多选",
        title: "请选择以下选项 (多选)",
        subtitle: "单选题",
        option: "选项",
        trackName: "multiple_select"
      },
      "4": {
        template: "q-matrix-default",
        name: "矩阵选择",
        title: "请选择以下选项",
        option: "选项",
        suboption: "矩阵行",
        trackName: "matrix_select"
      },
      "5": {
        template: "q-matrix-default",
        name: "矩阵选择",
        title: "矩阵单选题",
        option: "选项",
        suboption: "矩阵行",
        trackName: "matrix_select"
      },
      "6": {
        template: "q-blank",
        name: "填空",
        formName: "填空",
        title: "请填写本项内容",
        trackName: "blank"
      },
      "7": {
        template: "q-matrix-default",
        name: "矩阵打分",
        title: "请给以下各项打分",
        satisTitle: "请问你对以下描述的感觉是",
        option: "打分",
        suboption: "矩阵行",
        trackName: "matrix_blank"
      },
      "8": {
        template: "q-blank",
        name: "级联题",
        title: "出生日期",
        trackName: "date"
      },
      "9": {
        template: "q-classification",
        name: "分类",
        title: "请按照分类规则，将左侧选项拖入右侧分组中",
        option: "选项",
        suboption: "类别",
        trackName: "classification"
      },
      "50": {
        template: "q-score",
        name: "打分",
        formName: "打分",
        title: "请给本项打分",
        appraiseTitle: "以下人员在沟通能力方面，能够做到善于沟通，合理协调。",
        option: "选项",
        trackName: "score"
      },
      "60": {
        template: "q-default",
        name: "排序",
        formName: "排序",
        title: "请给以下选项排序",
        option: "选项",
        trackName: "sort"
      },
      "70": {
        template: "q-desc",
        name: "段落说明",
        title: "请阅读本项说明，然后回答问题",
        trackName: "remark"
      },
      "95": {
        template: "q-multi-blank",
        name: "多项填空",
        title: "请填写以下内容",
        option: "填空",
        trackName: "multiple_blank"
      },
      "100": {
        template: "q-matrix-default",
        name: "矩阵填空",
        title: "请填写以下内容",
        option: "填空",
        suboption: "矩阵行",
        trackName: "matrix_blank"
      },
      "105": {
        template: "q-goods",
        name: "商品",
        formName: "商品",
        title: "请挑选您喜欢的商品",
        subtitle: "商品题",
        option: "选项",
        trackName: "goods"
      },
      collection: {
        template: "q-collection",
        name: "收款题",
        formName: "收款",
        createFn: "createCollection",
        trackName: "collection"
      },
      contact_us: {
        template: "q-contact-us",
        name: "联系我们",
        createFn: "createContactUs",
        trackName: "contact_us"
      },
      enterprise_certification_info: {
        template: "q-enterprise-auth",
        createFn: "createEnterpriseAuth",
        name: "企业认证",
        trackName: "enterprise_certification_info"
      },
      user_info: {
        template: "q-user-info",
        name: "个人信息",
        title: "个人信息录入"
      },
      exam_inform: {
        template: "q-exam-inform",
        name: "考前须知",
        title: "考前须知"
      },
      geographical_multiple_blank: {
        template: "q-geographical",
        name: "地理位置",
        title: "所在位置",
        trackName: "geography"
      },
      rich_text: {
        template: "q-rich",
        name: "图文介绍",
        title: "请阅读本项说明，然后回答问题",
        trackName: "rich"
      },
      occupation: {
        template: "q-select",
        name: "职业",
        title: "您目前的职业是？",
        option: "在校学生",
        suboption: "政府/机关干部/公务员",
        trackName: "occupation"
      },
      singlevote: {
        template: "q-default",
        name: "文字投票",
        title: "请给以下选项投票",
        option: "选项",
        trackName: "font_vote"
      },
      education: {
        template: "q-select",
        name: "学历",
        title: "您的最高学历（含目前在读）是？",
        option: "小学及以下",
        suboption: "初中",
        trackName: "education"
      },
      sex: {
        template: "q-select",
        name: "性别",
        title: "性别",
        option: "男",
        suboption: "女",
        trackName: "sex"
      },
      age: {
        template: "q-select",
        name: "年龄",
        satisName: "年龄段",
        title: "您的年龄是？",
        option: "18岁以下",
        suboption: "18~24岁",
        trackName: "age"
      },
      judge: {
        template: "q-select",
        name: "判断题",
        title: "请判断本项叙述是否正确？",
        option: "是",
        suboption: "否",
        trackName: "single_select"
      },
      multiplevote: {
        template: "q-default",
        name: "文字投票题",
        title: "请给以下选项投票（多选）",
        option: "选项",
        trackName: "font_vote_multiple"
      },
      groupvote_single: {
        template: "q-video-vote",
        name: "分组投票",
        title: "请给以下分组投票",
        option: "选项",
        trackName: "groupvote_single"
      },
      groupvote_multiple: {
        template: "q-video-vote",
        name: "分组投票",
        title: "请给以下分组投票（多选）",
        option: "选项",
        trackName: "groupvote_multiple"
      },
      videovote_single: {
        template: "q-video-vote",
        name: "视频投票",
        title: "请给以下视频投票"
      },
      videovote_multiple: {
        template: "q-video-vote",
        name: "视频投票",
        title: "请给以下视频投票（多选）"
      },
      listening_single: {
        template: "q-select",
        name: "听力题",
        title: "点击上传音频/视频文件",
        option: "选项",
        trackName: "listen"
      },
      dropdown: {
        template: "q-default",
        name: "下拉",
        formName: "下拉",
        title: "请选择一个选项",
        option: "选项",
        trackName: "dropdown"
      },
      short_answer: {
        template: "q-blank",
        name: "简答题",
        title: "请简要阐述你的观点",
        trackName: "short_answer"
      },
      name: {
        template: "q-blank",
        name: "姓名",
        title: "姓名",
        trackName: "name"
      },
      mobile: {
        template: "q-blank",
        name: "手机",
        title: "手机",
        trackName: "mobile"
      },
      email: {
        template: "q-blank",
        name: "邮箱",
        title: "邮箱",
        trackName: "email"
      },
      wechat_id: {
        template: "q-blank",
        name: "微信号",
        title: "微信号",
        trackName: "wechat_id"
      },
      id_card: {
        template: "q-blank",
        name: "身份证号",
        title: "身份证号",
        trackName: "id_card"
      },
      employee_id: {
        template: "q-blank",
        name: "工号",
        title: "工号",
        trackName: "employee_id"
      },
      blank_num: {
        template: "q-blank",
        name: "数字填空",
        title: "数字",
        trackName: "blank_num"
      },
      classes: {
        template: "q-blank",
        name: "班级",
        title: "班级",
        trackName: "classes"
      },
      grades: {
        template: "q-blank",
        name: "年级",
        title: "年级",
        trackName: "grades"
      },
      student_id: {
        template: "q-blank",
        name: "学号",
        title: "学号",
        trackName: "student_id"
      },
      company: {
        template: "q-blank",
        name: "公司",
        title: "公司",
        trackName: "company"
      },
      department: {
        template: "q-blank",
        name: "部门",
        title: "部门",
        trackName: "department"
      },
      university_form: {
        template: "q-blank",
        name: "学校",
        title: "学校",
        trackName: "university_form"
      },
      major_form: {
        template: "q-blank",
        name: "专业",
        title: "专业",
        trackName: "major_form"
      },
      phone: {
        template: "q-phone",
        trackName: "mobile"
      },
      multi_line_blank: {
        template: "q-multiline-blank",
        trackName: "multiple_blank"
      },
      auto_table: {
        template: "q-auto-table",
        name: "自增表格",
        title: "请填写你的团队成员信息",
        option: "标题",
        trackName: "auto_table"
      },
      horz_blank: {
        template: "q-horz-blank",
        name: "横向填空",
        title: "请填写以下信息",
        option: '姓名<span class="ipt-wrap"><input type="text" style="width: 64px"></span>年龄<span class="ipt-wrap"><input type="text" style="width: 32px"></span>岁<br>联系方式<span class="ipt-wrap"><input type="text" style="width: 88px"></span>',
        trackName: "horizontal_blank"
      },
      cloze: {
        template: "q-cloze",
        name: "完形填空",
        title: "完形填空",
        trackName: "cloze"
      },
      banked_cloze: {
        template: "q-banked-cloze",
        name: "选词填空",
        title: "选词填空",
        option: "选项",
        suboption: ["请输入标题", "的", "地", "得"],
        trackName: "banked_cloze"
      },
      date: {
        template: "q-blank",
        name: "日期",
        title: "日期",
        trackName: "date"
      },
      upload_file: {
        template: "q-upload-file",
        name: "文件收集",
        title: "请上传文件",
        trackName: "upload"
      },
      image_upload: {
        template: "q-image-upload",
        name: "图片收集",
        assessName: "图片收集",
        title: "请上传图片",
        trackName: "image_upload"
      },
      time: {
        template: "q-time",
        name: "时间",
        title: "时间",
        trackName: "time"
      },
      signature: {
        template: "q-signature",
        name: "电子签名",
        subtitle: "请在此处签名",
        title: "签名",
        trackName: "signature"
      },
      image_single: {
        template: "q-image",
        name: "图片选择",
        formName: "图片单选",
        title: "请选择以下图片",
        option: "图片",
        trackName: "image_select"
      },
      image_multiple: {
        template: "q-image",
        name: "图片多选",
        title: "请选择以下图片（多选）",
        option: "图片",
        trackName: "image_multiple"
      },
      imagevote_single: {
        template: "q-video-vote",
        name: "图片投票",
        title: "请给以下图片投票",
        option: "图片",
        trackName: "image_vote"
      },
      imagevote_multiple: {
        template: "q-video-vote",
        name: "图片投票",
        title: "请给以下图片投票（多选）",
        option: "图片",
        trackName: "image_vote"
      },
      nps_score: {
        template: "q-nps-score",
        name: "NPS",
        formName: "NPS",
        title: "您向朋友或同事推荐我们的可能性有多大？",
        trackName: "nps"
      },
      scale: {
        template: "q-scale",
        name: "量表",
        title: "请您对此项目进行评价",
        satisTitle: "请问你对以下描述的感觉是",
        option: "标题",
        trackName: "scale"
      },
      matrix_scale: {
        template: "q-matrix-scale",
        name: "矩阵量表",
        title: "请您对以下各行内容进行评价",
        satisTitle: "请问你对以下描述的感觉是",
        appraiseTitle: "以下人员在沟通能力方面，能够做到善于沟通，合理协调。",
        option: "标题",
        trackName: "matrix_scale"
      },
      city: {
        template: "q-city",
        trackName: "address"
      },
      address: {
        template: "q-address",
        name: "城市/地址",
        formName: "城市/地址",
        satisName: "城市",
        title: "地址",
        trackName: "address"
      },
      major: {
        template: "q-cascader",
        name: "专业",
        trackName: "major"
      },
      industry: {
        template: "q-cascader",
        name: "行业",
        trackName: "industry"
      },
      cascader: {
        template: "q-cascader",
        name: "多级下拉",
        formName: "多级下拉",
        title: "请选择以下选项",
        trackName: "cascader"
      },
      university: {
        template: "q-cascader",
        name: "院校",
        trackName: "university"
      },
      proportion: {
        template: "q-proportion",
        name: "比重",
        formName: "比重",
        title: "请选择以下各项所占的百分比",
        option: "选项",
        trackName: "proportion"
      },
      evaluation: {
        template: "q-evaluation",
        name: "评价",
        formName: "评价",
        title: "请您对我们的服务进行评价",
        subtitle: "单选题",
        option: "选项",
        trackName: "evaluation"
      },
      split_line: {
        template: "q-split-line",
        name: "分割线",
        trackName: "split_line"
      },
      countdown: {
        template: "q-count-down",
        name: "倒计时",
        trackName: "pc_q_count_down"
      },
      countdown_show_only: {
        template: "q-count-down",
        name: "倒计时",
        trackName: "pc_q_count_down"
      },
      score_single: {
        template: "q-select",
        title: "请问你对以下描述的感觉是",
        name: "评分单选",
        trackName: "pc_q_grade_single"
      },
      work_age: {
        template: "q-select",
        title: "您的工作年限是？",
        name: "工龄",
        trackName: "pc_q_seniority"
      },
      base_info: {
        template: "q-multi-blank",
        title: "请填写您的基本信息",
        name: "基本信息",
        trackName: "pc_q_basic"
      },
      navigation: {
        template: "q-navigation",
        name: "地图导航",
        trackName: "navigation",
        title: "导航到这里"
      },
      page: {
        template: "q-page",
        name: "分页",
        trackName: "page"
      },
      multiple_dropdown: {
        template: "q-default",
        name: "下拉",
        title: "请选择以下选项 (多选)",
        option: "选项",
        trackName: "dropdown"
      },
      delivery_address: {
        template: "q-delivery-address",
        name: "收货信息",
        title: "请输入收货信息",
        trackName: "delivery_address"
      },
      ...expendsData
    };
    return {
      typeList: Object.keys(types),
      typesData: types,
      // 正向操作
      has() {
        for (var _len5 = arguments.length, keys = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          keys[_key5] = arguments[_key5];
        }
        return keys.every(item => this.typeList.includes(item));
      },
      // 反向操作
      revHas(name) {
        let prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "name";
        let typeKey = "undefined";
        this.typeList.find(
        // eslint-disable-next-line no-return-assign
        key => {
          var _types$key;
          return (types === null || types === void 0 ? void 0 : (_types$key = types[key]) === null || _types$key === void 0 ? void 0 : _types$key[prop]) === name && (typeKey = key);
        });
        return typeKey;
      }
    };
  },
  //  新增接口参数
  appendLoginParams(params) {
    var _this$$route;
    const {
      page_id,
      invite_id,
      reg_from_source,
      reg_fromm_id
    } = (this === null || this === void 0 ? void 0 : (_this$$route = this.$route) === null || _this$$route === void 0 ? void 0 : _this$$route.query) || {};
    const obj = {
      page_id,
      invite_id,
      reg_from_source,
      reg_fromm_id
    };
    Object.keys(obj).forEach(key => {
      if (obj[key] == 0 || !!obj[key]) params[key] = obj[key];
    });
  },
  usePWASignature: _assets_js_utils_use_pwa_signature_js__WEBPACK_IMPORTED_MODULE_0__,
  logTracker: _assets_js_utils_log_tracking_index_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  defineFunction,
  defineObject,
  useHooks,
  useObjects,
  hooks: {
    install(Vm) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      /**
       * @author: wei
       * @date 24.01.08
       * @description 项目中必使用的扩展函数
       */
      const [FactoryVue, getCurrentInstanceFc] = [Vm, options === null || options === void 0 ? void 0 : options.getCurrentInstance];
      Object.assign(FactoryVue, {
        [`${preFix}Instance`]: () => getCurrentInstanceFc().proxy,
        [`${preFix}Router`]: () => getCurrentInstanceFc().proxy.$router,
        [`${preFix}Route`]: () => getCurrentInstanceFc().proxy.$route,
        [`${preFix}State`]: () => {
          var _getCurrentInstanceFc;
          return (_getCurrentInstanceFc = getCurrentInstanceFc().proxy.$store) === null || _getCurrentInstanceFc === void 0 ? void 0 : _getCurrentInstanceFc.state;
        },
        [`${preFix}Refs`]: () => getCurrentInstanceFc().proxy.$refs,
        [`${preFix}Options`]: options => Object.assign(getCurrentInstanceFc().proxy.$options, options),
        [`${preFix}ReplaceRoute`]() {
          const formatUrl = function () {
            let {
              path = "",
              query = {}
            } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return `${path}${path.includes("?") ? "&" : Object.keys(query).length ? "?" : ""}${Object.keys(query).reduce((p, n, i) => `${p}${i ? "&" : ""}${n}=${query[n]}`, "")}`;
          };
          const setRoute = params => Promise.resolve(history.replaceState(null, null, formatUrl(params)));
          try {
            const {
              useRouter
            } = Vm;
            const Router = useRouter();
            return params => {
              const {
                currentRoute: {
                  path: currentRoutePath = "/"
                }
              } = Router;
              const {
                path
              } = params;
              return path === currentRoutePath ? Router.replace(params).catch(e => {}) : setRoute(params);
            };
          } catch (e) {
            return setRoute;
          }
        },
        ...useHooks
      });
    },
    ...useHooks,
    ...useObjects
  }
};
// if (typeof exports !== "undefined") {
//     export default $wj_tools;
// }
// if (typeof module !== "undefined" && typeof module.exports !== "undefined") {
//     module.exports = $wj_tools;
// }

/* harmony default export */ __webpack_exports__["default"] = ($wj_tools);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(18)))

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/option");

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCreateProjectUrl", function() { return isCreateProjectUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isUsedPWASignature", function() { return isUsedPWASignature; });
/* harmony import */ var _tools_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/**
 * @description: 项目在 pwa 中访问时，创建项目的接口应带有 pwa 标记，方便后端统计项目创建方式
 */



// 创建项目相关接口
const createProjectUrl = ["/edit/ajax/survey_copy/",
// 复制模板
"/edit/api/create/",
// 空白创建
"/edit/api/copy/",
// 复制已有项目
"/edit/api/textproject/",
// 文本创建
"/edit/api/ref/" // 引用收藏的模板创建
];

// 判断 url 是否为创建项目接口
function isCreateProjectUrl(url) {
  return createProjectUrl.some(item => url.includes(item));
}

// 判断是否使用 pwa 的签名
function isUsedPWASignature(url) {
  const {
    isPWA
  } = Object(_tools_js__WEBPACK_IMPORTED_MODULE_0__[/* distinguishUserAgentUtils */ "b"])();
  if (isPWA && isCreateProjectUrl(url)) {
    return true;
  }
  return false;
}

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/option.css");

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/assets/js/utils/cookie.js
var cookie = __webpack_require__(5);

// CONCATENATED MODULE: ./src/assets/js/utils/log-tracking/base.js

class base_LogBase {
  constructor(source, url) {
    this.source = source;
    this.url = url;
  }
  static createHttpRequest() {
    if (window.ActiveXObject) {
      return new window.ActiveXObject("Microsoft.XMLHTTP");
    }
    if (window.XMLHttpRequest) {
      return new XMLHttpRequest();
    }
  }
  static formatLogData(data) {
    const result = {};
    Object.keys(data).forEach(key => {
      let value = typeof data[key] === "object" ? JSON.stringify(data[key]) : data[key];
      if (value !== null && typeof value !== "undefined") {
        value = value.toString();
      }
      result[key] = value;
    });
    return result;
  }

  // eslint-disable-next-line class-methods-use-this
  getExtraData() {
    const extraInfo = ["hawkeye_mid", "browser_id"]; // 默认必传的值
    const cookieData = {};
    extraInfo.forEach(key => {
      cookieData[key] = Object(cookie["b" /* get */])(key);
    });
    const browserData = {
      su: document.referrer
    };
    return Object.assign(cookieData, browserData, {
      pageurl: window.location.href
    });
  }
}
// CONCATENATED MODULE: ./src/assets/js/utils/log-tracking/ali-log-tracking.js

class ali_log_tracking_AliLog extends base_LogBase {
  constructor(module) {
    const host = "cn-shanghai.log.aliyuncs.com";
    const project = "wj-applog-prod-10001-sls";
    const logstore = "wj-fed-user-operationlog";
    const url = `//${project}.${host}/logstores/${logstore}/track?APIVersion=0.6.0`;
    super(module, url);
  }
  push(topic, logData) {
    const postData = this.getPostData(topic, logData);
    const request = base_LogBase.createHttpRequest();
    try {
      request.open("POST", this.url, true);
      request.setRequestHeader("x-log-bodyrawsize", 0);
      request.send(JSON.stringify(postData));
    } catch (e) {
      var _window;
      if ((_window = window) !== null && _window !== void 0 && _window.console && typeof window.console.log === "function") {
        console.log(`Failed to log to ali log service because of this exception:\n${e}`);
        console.log("Failed log data:", this.url);
      }
    }
  }
  getExtraData() {
    const extraInfo = super.getExtraData();
    return {
      ...extraInfo
    };
  }
  getPostData(topic, logData) {
    const data = Object.assign(logData, this.getExtraData());
    const logContents = base_LogBase.formatLogData(data);
    return {
      __topic__: topic,
      __source__: this.module,
      __logs__: [logContents]
    };
  }
}
// CONCATENATED MODULE: ./src/assets/js/utils/log-tracking/tencent-log-tracking.js

class tencent_log_tracking_TencentLog extends base_LogBase {
  constructor(module) {
    const url = "https://ap-shanghai.cls.tencentcs.com/tracklog?topic_id=89daeb82-6d65-41e9-8a95-f70c8d52ed52";
    super(module, url);
  }
  push(topic, logData) {
    const postData = this.getPostData(topic, logData);
    const request = base_LogBase.createHttpRequest();
    try {
      request.open("POST", this.url, true);
      request.setRequestHeader("Content-type", "application/json");
      request.send(JSON.stringify(postData));
    } catch (e) {
      var _window;
      if ((_window = window) !== null && _window !== void 0 && _window.console && typeof window.console.log === "function") {
        console.log(`Failed to log to tencent log service because of this exception:\n${e}`);
        console.log("Failed log data:", this.url);
      }
    }
  }
  getPostData(topic, logData) {
    var _window2, _window2$location;
    const data = Object.assign(logData, this.getExtraData());
    const logContents = base_LogBase.formatLogData(data);
    return {
      logs: [{
        contents: {
          topic,
          module: this.module,
          ...logContents
        },
        time: new Date().getTime() // TODO: 是否可以不传
      }],

      source: ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.href) || "unknown"
    };
  }
}
// CONCATENATED MODULE: ./src/assets/js/utils/log-tracking/index.js


/* harmony default export */ var log_tracking = __webpack_exports__["a"] = ({
  AliLog: ali_log_tracking_AliLog,
  TencentLog: tencent_log_tracking_TencentLog
});

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/input.css");

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/card-item/src/card-item.vue?vue&type=template&id=5c2b92cf&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        `new-card-item card-type-${_vm.cardType}`,
        { hoverStatus: _vm.hoverStatus, autoAnimation: _vm.autoAnimation }
      ],
      style: _vm.styleConf,
      on: { click: _vm.click }
    },
    [
      _c("div", { staticClass: "card-content" }, [
        _c(
          "div",
          { staticClass: "image-wrap" },
          [
            _vm._t(
              "image",
              function() {
                return [
                  _c("img", {
                    staticClass: "pre-image",
                    attrs: {
                      src: _vm.data[_vm.property.thumbnail],
                      alt: "问卷网",
                      width: "100%"
                    }
                  })
                ]
              },
              { item: _vm.data }
            )
          ],
          2
        ),
        _vm._v(" "),
        _vm.cardType === 0
          ? _c(
              "div",
              {
                staticClass: "hover-import",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.clickImportTask.apply(null, arguments)
                  }
                }
              },
              [
                _vm._t("hoverText", function() {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.importText) +
                        "\n            "
                    )
                  ]
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data[_vm.property.isOfficial] && _vm.cardType === 0
          ? _c("img", {
              staticClass: "is-official",
              attrs: {
                src:
                  "//s1.wenjuan.com/assets/images/homesite/lib/position-top.svg",
                alt: "问卷网"
              }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.hideTitle
        ? _c("div", { staticClass: "title" }, [
            _c(
              "h3",
              { attrs: { title: _vm.data[_vm.property.title] } },
              [
                _vm._t("title", function() {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.data[_vm.property.title]) +
                        "\n            "
                    )
                  ]
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "desc" }, [
              _c("img", {
                staticClass: "icon",
                attrs: {
                  src: "//s1.wenjuan.com/assets/images/homesite/lib/masses.svg",
                  alt: "问卷网"
                }
              }),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.data[_vm.property.refCount] || 0) +
                  "\n        "
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/card-item/src/card-item.vue?vue&type=template&id=5c2b92cf&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/card-item/src/card-item.vue?vue&type=script&lang=js&
/* harmony default export */ var card_itemvue_type_script_lang_js_ = ({
  name: "CardItem",
  props: {
    // 控制hover 状态属性
    hoverStatus: {
      type: Boolean,
      default: false
    },
    // 组件对象
    data: {
      type: Object,
      default: Object
    },
    height: {
      type: [String, Number],
      default: null
    },
    width: {
      type: [String, Number],
      default: null
    },
    // 卡片类型，0：列表使用，1：大搜索搜索，2：小搜索使用 3: 迷你搜索框
    cardType: {
      type: Number,
      default: 0
    },
    props: {
      type: Object,
      default: Object
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    // 打开购买弹窗函数
    actionPackageDialog: {
      type: Function,
      default: null
    },
    // 引用拦截函数
    clickImport: {
      type: Function,
      default: null
    },
    importText: {
      type: String,
      default: "立即使用"
    },
    autoAnimation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      importting: false
    };
  },
  computed: {
    property() {
      return {
        title: "title",
        // 标题
        thumbnail: "thumbnail",
        // 图片地址
        questionCount: "question_count",
        // 题型数量
        refCount: "ref_count",
        // 引用数
        ishot: "is_hot",
        // 热门
        isOfficial: "is_official",
        sceneType: "scene_type",
        // 项目类型
        collectText: "collectText",
        showId: "project_short_id",
        // 弹窗需要的id
        collectStatus: "collect_status",
        // 是否收藏
        oid: "oid",
        // 调转页面用
        pFuncId: "p_func_id",
        projectId: "project_id",
        href: "href",
        // 跳转地址
        ...this.props
      };
    },
    styleConf() {
      const {
        width,
        height,
        setConf,
        cardType
      } = this;
      const style = {};
      if (width) style.width = ["%", "px"].includes(width) ? width : `${width}px`;
      if (height) style.height = ["%", "px"].includes(height) ? height : `${height}px`;
      Object.assign(style, setConf(cardType));
      return style;
    }
  },
  methods: {
    setConf(type) {
      return {
        // 正常尺寸
        0: {
          width: "212px",
          height: "337px"
        },
        // 大搜索尺寸
        1: {
          width: "136px",
          height: "181px"
        },
        // 小搜索尺寸
        2: {
          width: "100px",
          height: "134px"
        },
        // 迷你尺寸
        3: {
          width: "69px",
          height: "92px"
        }
      }[type];
    },
    click() {
      this.$emit("clickCard", this.data);
    },
    clickImportTask() {
      this.$emit("clickImport", this.data);
    }
  }
});
// CONCATENATED MODULE: ./packages/card-item/src/card-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_card_itemvue_type_script_lang_js_ = (card_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/card-item/src/card-item.vue?vue&type=style&index=0&id=5c2b92cf&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/card-item/src/card-item.vue?vue&type=style&index=0&id=5c2b92cf&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/card-item/src/card-item.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_card_itemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "5c2b92cf",
  null
  
)

/* harmony default export */ var card_item = (component.exports);
// CONCATENATED MODULE: ./packages/card-item/index.js

card_item.install = function (Vue) {
  Vue.component(card_item.name, card_item);
};
/* harmony default export */ var packages_card_item = __webpack_exports__["default"] = (card_item);

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/new-search/src/new-search.vue?vue&type=template&id=51f7d23c&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "new-search-input",
      class: [
        "new-search-input",
        { "small-size": _vm.type === 2, "mini-size": _vm.type === 3 }
      ]
    },
    [
      _c(
        "WdInput",
        {
          ref: "input",
          staticClass: "new-input",
          attrs: {
            placeholder: _vm.defineKeyword || _vm.defaultKeyword,
            clearable: ""
          },
          on: {
            focus: function($event) {
              _vm.onFocus = true
            },
            blur: _vm.blur,
            input: _vm.input,
            clear: function($event) {
              return _vm.$emit("clear")
            }
          },
          nativeOn: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.onSearch.apply(null, arguments)
            }
          },
          model: {
            value: _vm.searchVal,
            callback: function($$v) {
              _vm.searchVal = typeof $$v === "string" ? $$v.trim() : $$v
            },
            expression: "searchVal"
          }
        },
        [
          _vm.type === 1
            ? _c(
                "div",
                {
                  staticClass: "select",
                  attrs: { slot: "prepend" },
                  slot: "prepend"
                },
                [
                  _c(
                    "WdSelect",
                    {
                      staticClass: "select-body",
                      attrs: {
                        "popper-append-to-body": false,
                        size: "mini",
                        "popper-class": "select-popver",
                        placeholder: "全部"
                      },
                      on: {
                        change: function($event) {
                          return _vm.$emit("selectChange", _vm.libType)
                        }
                      },
                      model: {
                        value: _vm.libType,
                        callback: function($$v) {
                          _vm.libType = $$v
                        },
                        expression: "libType"
                      }
                    },
                    _vm._l(_vm.options || _vm.libraryOptions, function(
                      option,
                      index
                    ) {
                      return _c("WdOption", {
                        key: `select-option-${index}`,
                        attrs: {
                          title: option.label,
                          label: option.label,
                          value: option.value
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("i", {
            staticClass: "wd-input__icon wd-icon-search",
            attrs: { slot: "append" },
            on: { click: _vm.onSearch },
            slot: "append"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                (!_vm.searchVal && _vm.showPanel) ||
                (_vm.showPanel &&
                  _vm.searchVal &&
                  (_vm.recommendList.length || _vm.searchList.length)) ||
                _vm.hoverStatus,
              expression:
                "\n            (!searchVal && showPanel) ||\n                (showPanel &&\n                    searchVal &&\n                    (recommendList.length || searchList.length)) ||\n                hoverStatus\n        "
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "new-search-over"
        },
        [
          _c(
            "section",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.searchVal,
                  expression: "!searchVal"
                }
              ],
              staticClass: "tag-module"
            },
            [
              _vm._t("panel", function() {
                return [
                  _c("NewSearchPanel", {
                    ref: "panel-component",
                    attrs: {
                      "local-key": _vm.localKey,
                      "search-val": _vm.searchVal,
                      "max-history-size": _vm.maxHistorySize,
                      "hot-list": _vm.hotList,
                      type: _vm.type
                    },
                    on: {
                      clickPanel: _vm.clickPanel,
                      removeHistory: _vm.removeHistory
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ data }) {
                            return _vm.$scopedSlots["panel-item"]
                              ? _vm._t("panel-item", null, { data: data })
                              : _vm._e()
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "section",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.searchVal,
                  expression: "searchVal"
                }
              ],
              staticClass: "search-mudole"
            },
            [
              _vm._t("result", function() {
                return [
                  _c(
                    "NewSearchResult",
                    {
                      ref: "search-result",
                      staticClass: "search-result",
                      attrs: {
                        "data-list": _vm.searchList,
                        "recommend-list": _vm.recommendList,
                        type: _vm.type,
                        "click-import": _vm.clickImport,
                        "re-number": _vm.reNumber
                      },
                      on: {
                        clickCard: _vm.clickCard,
                        clickFuzzyMatch: _vm.clickFuzzyMatch,
                        clickMore: function($event) {
                          return _vm.$emit("clickMore")
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "result-title",
                            fn: function({ data }) {
                              return _vm.$scopedSlots["result-title"]
                                ? [_vm._t("result-title", null, { data: data })]
                                : undefined
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _vm._v(" "),
                      _vm.$scopedSlots.image ? void 0 : _vm._e(),
                      _vm._v(" "),
                      _vm.$scopedSlots["search-result-recommend"]
                        ? _c(
                            "template",
                            { slot: "search-result-recommend" },
                            [_vm._t("search-result-recommend")],
                            2
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ]
              })
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/new-search/src/new-search.vue?vue&type=template&id=51f7d23c&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/option.css"
var option_css_ = __webpack_require__(162);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/option"
var option_ = __webpack_require__(143);
var option_default = /*#__PURE__*/__webpack_require__.n(option_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/select.css"
var select_css_ = __webpack_require__(51);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/select"
var select_ = __webpack_require__(35);
var select_default = /*#__PURE__*/__webpack_require__.n(select_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/input.css"
var input_css_ = __webpack_require__(19);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/input"
var input_ = __webpack_require__(9);
var input_default = /*#__PURE__*/__webpack_require__.n(input_);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(1);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./src/http/library-center/index.js

let request = external_vue_default.a.prototype.commonRequest;
const api = fn => {
  request = external_vue_default.a.prototype.commonRequest;
  return fn();
};
const searchPlaceholder = () => api(() => request.get("/api/project_lib/search/placeholder/"));
const sceneTypeDesc = () => api(() => request.get("/api/project_lib/search/scene_type_desc/"));
const searchTrendingKeywords = () => api(() => request.get("/api/project_lib/search/trending_keywords/"));
const importCardItem = data => api(() => request.post("/edit/ajax/survey_copy/", data));

/**
 * 轮询接口，轮询获取复制异步任务是否完成
 * @param {*}
 */
function httpGetAsyncCopyStatus(params) {
  const {
    pid
  } = params;
  return api(() => request.get(`/edit/api/get_copy_project_status/${pid}/`));
}

// 发送付费套餐线索
const sendPayClue = data => api(() => request.post("/api/cms_pay_clue/pay_clue/create/", data));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/new-search/src/new-search-panel.vue?vue&type=template&id=3b2d3cc2&scoped=true&
var new_search_panelvue_type_template_id_3b2d3cc2_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "new-search-tag-panel" },
    [
      _vm._l(_vm.panelList, function(item, index) {
        return [
          item.list && item.list.length
            ? _c("div", { key: index, staticClass: "content" }, [
                _c("span", { staticClass: "title" }, [
                  _c("span", { staticClass: "common-dark-text" }, [
                    _vm._v(_vm._s(item.title))
                  ]),
                  _vm._v(" "),
                  item.useRemove
                    ? _c("i", {
                        staticClass: "remove-icon wd-icon-delete",
                        on: { click: _vm.removeHistory }
                      })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    class: [
                      "tag-list",
                      { [`search-type-${_vm.type}`]: _vm.type }
                    ]
                  },
                  _vm._l(item.list || [], function(ite, i) {
                    return _c(
                      "li",
                      {
                        key: `li_${index}_${i}`,
                        staticClass: "tag",
                        attrs: { title: ite.length > 8 ? ite : "" },
                        on: {
                          click: function($event) {
                            return _vm.click(ite, item)
                          }
                        }
                      },
                      [
                        _vm._t(
                          "default",
                          function() {
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(ite) +
                                  "\n                    "
                              )
                            ]
                          },
                          { data: ite }
                        )
                      ],
                      2
                    )
                  }),
                  0
                )
              ])
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var new_search_panelvue_type_template_id_3b2d3cc2_scoped_true_staticRenderFns = []
new_search_panelvue_type_template_id_3b2d3cc2_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/new-search/src/new-search-panel.vue?vue&type=template&id=3b2d3cc2&scoped=true&

// EXTERNAL MODULE: ./packages/tools.js
var tools = __webpack_require__(11);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/new-search/src/new-search-panel.vue?vue&type=script&lang=js&


const {
  useHooks: {
    useLocal
  }
} = tools["default"];
/* harmony default export */ var new_search_panelvue_type_script_lang_js_ = ({
  props: {
    searchVal: {
      type: String,
      default: ""
    },
    /**
     * @return [{title,list:[],useMove:Boolean}]
     */
    dataList: {
      type: Array,
      default: () => []
    },
    // 缓存关键字
    localKey: {
      type: String,
      default: ""
    },
    // 最大存储历史数据个数
    maxHistorySize: {
      type: Number,
      default: 10
    },
    // 热门搜索
    hotList: {
      type: Array,
      default: null
    },
    // 搜索框类型
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      defineHotList: [],
      localData: {
        value: []
      }
    };
  },
  async fetch() {
    await this.init();
  },
  computed: {
    panelList() {
      const list = [];
      if (this.hotList) {
        list.push({
          title: "热门",
          list: this.hotList
        });
      }
      return (list.length ? list : this.defineHotList).concat({
        title: "历史",
        list: this.localData.value,
        useRemove: true
      });
    }
  },
  mounted() {
    this.getHistoryList();
  },
  methods: {
    async init() {
      await this.getHotList();
    },
    // 获取热门搜索词
    async getHotList() {
      try {
        const {
          data
        } = await searchTrendingKeywords();
        this.defineHotList = [{
          title: "热门",
          list: data
        }];
      } catch (error) {
        return Promise.reject(error);
      }
    },
    click(ite, item) {
      this.addHistoryItem(ite);
      this.$emit("clickPanel", ite, item);
    },
    // 获取历史查询记录
    getHistoryList() {
      this.localData = useLocal(this.localKey, []);
    },
    removeHistory() {
      this.$emit("removeHistory");
      this.localData.value = [];
    },
    addHistoryItem(searchValue) {
      if (!searchValue) return;
      const list = this.localData.value;
      const index = list.indexOf(searchValue);
      // eslint-disable-next-line no-bitwise
      if (~index) list.splice(index, 1);
      list.unshift(searchValue);
      this.saveHistory(list);
    },
    // 保存数据
    saveHistory(data) {
      this.localData.value = data.slice(0, this.maxHistorySize);
    }
  }
});
// CONCATENATED MODULE: ./packages/new-search/src/new-search-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_new_search_panelvue_type_script_lang_js_ = (new_search_panelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/new-search/src/new-search-panel.vue?vue&type=style&index=0&id=3b2d3cc2&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/new-search/src/new-search-panel.vue?vue&type=style&index=0&id=3b2d3cc2&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/new-search/src/new-search-panel.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_new_search_panelvue_type_script_lang_js_,
  new_search_panelvue_type_template_id_3b2d3cc2_scoped_true_render,
  new_search_panelvue_type_template_id_3b2d3cc2_scoped_true_staticRenderFns,
  false,
  null,
  "3b2d3cc2",
  null
  
)

/* harmony default export */ var new_search_panel = (component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/new-search/src/new-search-result.vue?vue&type=template&id=5018d74c&scoped=true&
var new_search_resultvue_type_template_id_5018d74c_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "new-sreach-result" }, [
    _c(
      "ul",
      { staticClass: "result-data" },
      _vm._l(_vm.dataList, function(item, index) {
        return _c(
          "li",
          {
            key: `searchData-item-${index}`,
            staticClass: "searchData-item",
            on: {
              click: function($event) {
                return _vm.$emit("clickFuzzyMatch", item)
              }
            }
          },
          [
            _vm._t(
              "result-title",
              function() {
                return [
                  _c("span", { staticClass: "result-title" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.title) +
                        "\n                "
                    )
                  ])
                ]
              },
              { data: item }
            )
          ],
          2
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "section",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.recommendList.length,
            expression: "recommendList.length"
          }
        ],
        staticClass: "remonmend"
      },
      [
        _c("div", { staticClass: "recommend-title" }, [
          _c("h3", [_vm._v("推荐模板")]),
          _vm._v(" "),
          _vm.type === 1
            ? _c(
                "span",
                {
                  staticClass: "renumber",
                  on: {
                    click: function($event) {
                      return _vm.$emit("clickMore")
                    }
                  }
                },
                [
                  _vm._v("还有" + _vm._s(_vm.reNumber) + "个 "),
                  _c("i", { staticClass: "wd-icon-caret-right" })
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "recommend-list" },
          [
            _vm._t("search-result-recommend", function() {
              return _vm._l(_vm.reData, function(item, index) {
                return _c(
                  "CardItem",
                  {
                    key: `recommend-item-${index}`,
                    attrs: {
                      data: item,
                      "card-type": _vm.type,
                      type: _vm.type,
                      "hide-title": "",
                      "click-import": _vm.clickImport,
                      "auto-animation": ""
                    },
                    on: { clickCard: _vm.clickCard }
                  },
                  [_vm.$slots.image ? void 0 : _vm._e()],
                  2
                )
              })
            })
          ],
          2
        )
      ]
    )
  ])
}
var new_search_resultvue_type_template_id_5018d74c_scoped_true_staticRenderFns = []
new_search_resultvue_type_template_id_5018d74c_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/new-search/src/new-search-result.vue?vue&type=template&id=5018d74c&scoped=true&

// EXTERNAL MODULE: ./packages/card-item/index.js + 7 modules
var card_item = __webpack_require__(225);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/new-search/src/new-search-result.vue?vue&type=script&lang=js&

/* harmony default export */ var new_search_resultvue_type_script_lang_js_ = ({
  name: "NewSreachResult",
  components: {
    CardItem: card_item["default"]
  },
  props: {
    // 关联项目
    dataList: {
      type: Array,
      default: () => []
    },
    // 推荐专题
    recommendList: {
      type: Array,
      default: () => []
    },
    // 还剩多少专题
    reNumber: {
      type: Number,
      default: 0
    },
    // 1 是大搜索 2 是小搜索
    type: {
      type: Number,
      default: 1
    },
    // 引用函数
    clickImport: {
      type: Function,
      default: null
    }
  },
  computed: {
    reData() {
      return this.recommendList.slice(0, this.type === 1 ? 4 : 2);
    }
  },
  methods: {
    clickCard(item) {
      this.$emit("clickCard", item);
    }
  }
});
// CONCATENATED MODULE: ./packages/new-search/src/new-search-result.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_new_search_resultvue_type_script_lang_js_ = (new_search_resultvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/new-search/src/new-search-result.vue?vue&type=style&index=0&id=5018d74c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/new-search/src/new-search-result.vue?vue&type=style&index=0&id=5018d74c&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/new-search/src/new-search-result.vue






/* normalize component */

var new_search_result_component = Object(componentNormalizer["a" /* default */])(
  src_new_search_resultvue_type_script_lang_js_,
  new_search_resultvue_type_template_id_5018d74c_scoped_true_render,
  new_search_resultvue_type_template_id_5018d74c_scoped_true_staticRenderFns,
  false,
  null,
  "5018d74c",
  null
  
)

/* harmony default export */ var new_search_result = (new_search_result_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/new-search/src/new-search.vue?vue&type=script&lang=js&









/* harmony default export */ var new_searchvue_type_script_lang_js_ = ({
  name: "NewSearchInput",
  components: {
    WdInput: input_default.a,
    WdSelect: select_default.a,
    WdOption: option_default.a,
    NewSearchPanel: new_search_panel,
    NewSearchResult: new_search_result
  },
  model: {
    prop: "keyword",
    event: "myInput"
  },
  props: {
    // 是否出现弹窗
    hoverStatus: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: String,
      default: ""
    },
    // 1 大搜索框， 2 小搜索框,3:mini 搜索宽度
    type: {
      type: Number,
      default: 1
    },
    // 下拉选项配置
    options: {
      type: Array,
      default: null
    },
    // 最大存储历史数据个数
    maxHistorySize: {
      type: Number,
      default: 10
    },
    // 卡片属性配置化
    cradProperty: {
      type: Object,
      default: null
    },
    // 搜索关键字
    searchList: {
      type: Array,
      default: () => []
    },
    // 关联推荐列表
    recommendList: {
      type: Array,
      default: () => []
    },
    // 点击引用模板
    clickImport: {
      type: Function,
      default: null
    },
    // 热门项目
    hotList: {
      type: Array,
      default: null
    },
    // 还剩多少专题
    reNumber: {
      type: Number,
      default: 0
    },
    // 缓存的key名称
    localKey: {
      type: String,
      default: "searchCache"
    },
    // 用来控制 弹出面板是不是需要加载动作<由外部设置>
    loading: {
      type: Boolean,
      default: false
    },
    isSsr: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      searchVal: "",
      // 搜索关键字
      libType: 0,
      // 场景类型
      libraryOptions: [{
        label: "全部",
        value: 0
      }],
      // 下来选项场景
      defineKeyword: "",
      // 设置的搜索词
      onFocus: false,
      // 是不是失去焦点
      keepMutie: false,
      // 短期保持状态
      defaultKeyword: "请输入想搜索的模板"
    };
  },
  async fetch() {
    await this.init();
  },
  computed: {
    showPanel() {
      const {
        onFocus,
        hoverStatus
      } = this;
      return onFocus || hoverStatus;
    }
  },
  watch: {
    // 关联当前搜索词语
    keyword: {
      handler(cval) {
        this.searchVal = cval;
      },
      immediate: true
    }
  },
  mounted() {
    if (!this.isSsr) this.init();
  },
  fetchOnServer: true,
  methods: {
    async init() {
      try {
        await Promise.all([this.fetchSearchDefaultOpts(), this.fetchlibTypeOptions()]);
      } catch (error) {
        console.log("fetch error: ", error);
      }
    },
    // 获取搜索框的默认配置，后台配置
    async fetchSearchDefaultOpts() {
      try {
        const {
          data
        } = await searchPlaceholder();
        const {
          project_library_count,
          set_keyword,
          default_keyword
        } = data;
        this.defineKeyword = set_keyword || default_keyword || "";
        this.defaultKeyword = project_library_count ? `${project_library_count || 0}份模板任你选用` : "请输入想搜索的模板";
      } catch (error) {
        return Promise.reject(error);
      }
    },
    // 获取场景下拉选项数据
    async fetchlibTypeOptions() {
      // eslint-disable-next-line no-return-assign
      if (this.options) return this.libraryOptions = this.options;
      // auto get options
      try {
        const {
          data
        } = await sceneTypeDesc();
        this.libraryOptions = [{
          label: "全部",
          value: 0
        }].concat(data.map(item => ({
          label: item.title,
          value: item.scene_number
        })));
      } catch (error) {
        return Promise.reject(error);
      }
    },
    onSearch() {
      this.addHistoryItem(this.searchVal);
      // run custom define function task
      this.$emit("onSearch", {
        keyword: this.searchVal,
        scene: this.libType
      });
      // define task function
    },

    // 查找匹配字段
    clickFuzzyMatch(item) {
      this.addHistoryItem(item.title);
      this.$emit("clickFuzzyMatch", item);
      // todo add jump
    },

    // 失去焦点, 必须延迟执行
    blur() {
      setTimeout(() => {
        if (this.keepMutie) {
          this.keepMutie = false;
        } else {
          this.onFocus = false;
        }
      }, 150);
    },
    removeHistory() {
      this.keepMutie = true;
      this.focus();
      this.$emit("removeHistory");
    },
    // 打开预览弹窗
    clickCard(item) {
      if (item !== null && item !== void 0 && item.title) {
        this.addHistoryItem(item.title);
      }
      this.$emit("clickCard", item);
    },
    //  点击panel 面板内容
    clickPanel() {
      for (var _len = arguments.length, parmas = new Array(_len), _key = 0; _key < _len; _key++) {
        parmas[_key] = arguments[_key];
      }
      this.$emit("clickPanel", ...parmas);
    },
    // 获取聚焦
    focus() {
      var _this$$refs;
      this.onFocus = true;
      (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.input.focus();
    },
    // 辅助函数
    // 保存历史记录
    addHistoryItem(value) {
      const {
        $refs: {
          "panel-component": panelComponent
        }
      } = this;
      panelComponent === null || panelComponent === void 0 ? void 0 : panelComponent.addHistoryItem(value);
    },
    // 双向绑定
    input() {
      this.$emit("myInput", this.searchVal);
      this.$emit("input", this.searchVal, this.libType);
    }
  },
  setConf() {
    let ssrType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (ssrType) {
      this.fetchOnServer = true;
    } else {
      this.mounted = function () {
        this.init();
      };
    }
  }
});
// CONCATENATED MODULE: ./packages/new-search/src/new-search.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_new_searchvue_type_script_lang_js_ = (new_searchvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/new-search/src/new-search.vue?vue&type=style&index=0&id=51f7d23c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/new-search/src/new-search.vue?vue&type=style&index=0&id=51f7d23c&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/new-search/src/new-search.vue?vue&type=style&index=1&id=51f7d23c&prod&lang=scss&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/new-search/src/new-search.vue?vue&type=style&index=1&id=51f7d23c&prod&lang=scss&

// CONCATENATED MODULE: ./packages/new-search/src/new-search.vue







/* normalize component */

var new_search_component = Object(componentNormalizer["a" /* default */])(
  src_new_searchvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "51f7d23c",
  null
  
)

/* harmony default export */ var new_search = (new_search_component.exports);
// CONCATENATED MODULE: ./packages/new-search/index.js

new_search.install = function (Vue) {
  Vue.component(new_search.name, new_search);
};
/* harmony default export */ var packages_new_search = __webpack_exports__["default"] = (new_search);

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/select");

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getQueryString; });
/* unused harmony export hideMobile */
/* unused harmony export isNotEmpty */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return distinguishUserAgentUtils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return loadJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return urlDelP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataURLtoFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return downloadGenerateQRCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUserAgentInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isWxMiniApp; });
/* unused harmony export insertHTML */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleAppClintPostMes; });
// 获取url链接中的参数
function getQueryString(name) {
  let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
  const r = source.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

// 手机打*号
function hideMobile(mobile) {
  if (!mobile) return "";
  return `${mobile.substr(0, 3)}****${mobile.substr(-4)}`;
}

// 判断变量是否为空
function isNotEmpty(obj) {
  if (typeof obj === "undefined" || obj == null) {
    return false;
  }
  if (typeof obj === "function") {
    return true;
  }
  if (obj.constructor == Number) {
    if (obj) {
      return true;
    }
    return false;
  }
  if (typeof obj === "string") {
    if (obj !== "") {
      return true;
    }
    return false;
  }
  return Object.keys(obj).length > 0;
}

// 区分浏览器类型
function distinguishUserAgentUtils(userAgent) {
  if (typeof window !== "undefined") {
    var _window, _window$navigator, _window2;
    const ua = userAgent || ((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent.toLowerCase());
    const isTouTiaoMiniApp = ua.includes("toutiaomicroapp");
    const isQQMiniApp = ua.includes("qq") && ua.includes("miniprogram") && !ua.includes("micromessenger");
    const isBaiduMiniApp = ua.includes("baiduboxapp") && ua.includes("swan");
    const isWeixinMiniApp = ua.includes("micromessenger") && ua.includes("miniprogram");
    return {
      isEdge: ua.includes("Edge"),
      isFF: ua.includes("Firefox"),
      isOpera: ua.includes("Opera"),
      isBB: ua.includes("BlackBerry"),
      isChrome: ua.includes("Chrome"),
      isMaxthon: ua.includes("Maxthon"),
      isFeishu: ua.includes("Lark/"),
      isIos: /(iPhone|iPad|iPod|iOS)/i.test(ua),
      isSafari: ua.includes("Safari") && !ua.includes("Chrome"),
      isIE: !!window.ActiveXObject || "ActiveXObject" in window,
      isMobile: /(iPad|iPhone|iPod|Opera Mini|Android.*Mobile|NetFront|PSP|BlackBerry|Windows Phone)/gi.test(ua),
      isWeixin: ua.match(/MicroMessenger/i) === "micromessenger",
      isWeibo: ua.match(/WeiBo/i) === "weibo",
      isWxwork: ua.match(/wxwork/i) === "wxwork",
      isQQ: ua.match(/QQ/i) === "qq",
      isIosApp: ua.includes("wenjuan/") && /(iPhone|iPad|iPod|iOS)/i.test(ua),
      isApp: ua.includes("wenjuan/") || ua.includes("android_app/"),
      isTeacherApp: ua.includes("campusteacher/") || ua.includes("campusstudent/"),
      isHarmony: ua.includes("harmony_wenjuanwrap"),
      isAndroidApp: ua.includes("android_app/"),
      isAndroid: (ua.match(/android/i) === "android" || ua.match(/adr/i) === "adr") && ua !== "android_app/1.0.0",
      // ios android 客户端
      isNative: ua.match(/android_app\//i) === "android_app/" || ua.match(/wenjuan\//i) === "wenjuan/",
      isBaiying: ua.includes("baiying"),
      isDingding: ua.includes("DingTalk"),
      isTencentWemeet: ua.includes("tencent_wemeet"),
      isMac: /macintosh|mac os x/i.test(ua),
      isPWA: (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.matchMedia("(display-mode: minimal-ui)").matches,
      isUc: ua.includes("ucbrowser"),
      isCloudpay: ua.includes("unionpay"),
      isDingTalk: ua.includes("dingtalk"),
      isTencentMeeting: ua.includes("tencent_wemeet"),
      isQuark: ua.includes("quark"),
      isTouTiaoMiniApp,
      isQQMiniApp,
      isBaiduMiniApp,
      isWeixinMiniApp,
      isMiniApp: isTouTiaoMiniApp || isQQMiniApp || isBaiduMiniApp || isWeixinMiniApp,
      isHarmonyApp: ua.includes("harmonyos") && ua.includes("wenjuan/") && !ua.includes("android_app/")
    };
  }
  return {};
}

// js中动态加载script，并在load后触发cb
function loadJS(url, callback) {
  const script = document.createElement("script");
  const fn = callback || function () {};
  script.type = "text/javascript";
  // IE
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        script.onreadystatechange = null;
        fn();
      }
    };
  } else {
    // 其他浏览器
    script.onload = function () {
      fn();
    };
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

// 删除URL上某个参数
function urlDelP(url, name) {
  const urlArr = url.split("?");
  if (urlArr.length > 1 && urlArr[1].indexOf(name) > -1) {
    const query = urlArr[1];
    const obj = {};
    const arr = query.split("&");
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[name];
    const querys = JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
    let searchs = "";
    if (querys) {
      searchs = `?${querys}`;
    }
    const urlte = urlArr[0] + searchs;
    return urlte;
  }
  return url;
}
/**
 * 将base64转换为文件
 * @param {String} dataUrl 图片地址
 * @param {String} imgType 图片类型 传png,jpg等 而不是image/png
 * @return blob文件
 */
function dataURLtoFile(dataUrl, imgType) {
  var _arr$;
  // 替换base64图片的图片类型
  if (imgType) {
    const types = dataUrl.match(/data:image[^;]*;base64,/gi);
    types.forEach(type => {
      dataUrl = dataUrl.replace(new RegExp(`${type}`, "g"), `data:image/${imgType};base64,`);
    });
  }
  const arr = dataUrl.split(",");
  const reg = (_arr$ = arr[0]) === null || _arr$ === void 0 ? void 0 : _arr$.match(/:(.*?);/);
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: reg ? reg[1] : ""
  });
}

// 前端生成二维码-下载二维码
function downloadGenerateQRCode(url) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "图片";
  if (window.navigator.msSaveOrOpenBlob) {
    // ie
    const bstr = atob(url.split(",")[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const blob = new Blob([u8arr]);
    window.navigator.msSaveOrOpenBlob(blob, `${name}.png`);
  } else {
    // 非ie
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", `${name}.png`);
    a.click();
  }
}
function getUserAgentInfo() {
  const {
    userAgent
  } = navigator;
  let version;
  if (/opera/i.test(userAgent) || /OPR/i.test(userAgent)) {
    version = getVersion(userAgent, "OPR/(\\d+\\.+\\d+)");
    return ["Opera", version];
  }
  if (/compatible/i.test(userAgent) && /MSIE/i.test(userAgent)) {
    version = getVersion(userAgent, "MSIE (\\d+\\.+\\d+)");
    return ["IE", version];
  }
  if (/Edg/i.test(userAgent)) {
    version = getVersion(userAgent, "Edg/(\\d+\\.+\\d+)");
    return ["Edge", version];
  }
  if (/Firefox/i.test(userAgent)) {
    version = getVersion(userAgent, "Firefox/(\\d+\\.+\\d+)");
    return ["Firefox", version];
  }
  if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) {
    version = getVersion(userAgent, "Version/(\\d+\\.+\\d+)");
    return ["Safari", version];
  }
  if (/Chrome/i.test(userAgent) && /Safari/i.test(userAgent)) {
    version = getVersion(userAgent, "Chrome/(\\d+\\.+\\d+)");
    return ["Chrome", version];
  }
  if (userAgent.includes("Trident") || userAgent.includes("MSIE")) {
    return ["IE", "any"];
  }
}
function getVersion(userAgent, reg) {
  const reBrowser = new RegExp(reg);
  reBrowser.test(userAgent);
  return parseInt(RegExp.$1);
}

// 判断是否是小程序环境
function isWxMiniApp() {
  try {
    var _window3, _window3$navigator, _window3$navigator$us;
    const ua = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$navigator = _window3.navigator) === null || _window3$navigator === void 0 ? void 0 : (_window3$navigator$us = _window3$navigator.userAgent) === null || _window3$navigator$us === void 0 ? void 0 : _window3$navigator$us.toLowerCase();
    const uaIsWxMiniApp = ua.includes("micromessenger") && ua.includes("miniprogram");
    if (uaIsWxMiniApp) return true;
    const appname = getQueryString("appname");
    if (appname === "wj-miniapp") return true;
    if (window.__wxjs_environment === "miniprogram") return true;
  } catch (error) {}
}

// insert HTML
function insertHTML(html, editor) {
  if (window.getSelection) {
    // IE9 and non-IE
    const sel = window.getSelection();
    if (editor && sel.focusNode !== editor && sel.focusNode.parentNode !== editor) {
      editor.innerHTML += html;
      return;
    }
    if (sel.getRangeAt && sel.rangeCount) {
      let range = sel.getRangeAt(0);
      range.deleteContents();
      const el = document.createElement("div");
      el.innerHTML = html;
      const frag = document.createDocumentFragment();
      let node = el.firstChild;
      let lastNode;
      while (node) {
        lastNode = frag.appendChild(node);
        node = el.firstChild;
      }
      range.insertNode(frag);

      // Preserve the selection
      if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  } else if (document.selection && document.selection.type !== "Control") {
    // IE < 9
    document.selection.createRange().pasteHTML(html);
  }
}

// app端交互
function handleAppClintPostMes() {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    isIosApp,
    isAndroidApp,
    isHarmonyApp
  } = distinguishUserAgentUtils(navigator.userAgent);
  if (isHarmonyApp) {
    window.ohosCallNative && window.ohosCallNative.postMessage({
      type,
      data
    });
  } else if (isIosApp) {
    var _window$webkit;
    if ((_window$webkit = window.webkit) !== null && _window$webkit !== void 0 && _window$webkit.messageHandlers) {
      window.webkit.messageHandlers.app_nativeInteraction.postMessage({
        type,
        data
      });
    }
  } else if (isAndroidApp && window.android) {
    window.android.postMessage(JSON.stringify({
      type,
      data
    }));
  }
}

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return del; });
/* unused harmony export getParseDomain */
// 操作cookie
function set(c_name, value, expiredays, beforeDomain) {
  let exdate;
  const domain = getParseDomain(beforeDomain);
  // expiredays 可以是Number类型的过期天数
  // 也可以是String类型的日期字符串
  // 还可以是Date类型的
  if (expiredays && expiredays instanceof Date) {
    // expiredays是Date类型
    exdate = expiredays;
  } else if (expiredays && isDate(expiredays)) {
    // expiredays是日期字符串
    exdate = new Date(expiredays).toUTCString();
  } else {
    // expiredays为Nubmer类型或者未设置
    const newDate = new Date();
    expiredays = !expiredays || expiredays != Number(expiredays) ? 1 : expiredays;
    newDate.setDate(newDate.getDate() + expiredays);
    exdate = newDate.toUTCString();
  }
  document.cookie = `${c_name}=${escape(value)};expires=${exdate};path=/;domain=${domain}`;
}
function get(c_name) {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(`${c_name}=`);
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      let c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) c_end = document.cookie.length;
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}
function del(name) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const cval = get(name);
  const domain = getParseDomain();
  if (cval != null) {
    document.cookie = `${name}=${cval};expires=${exp.toUTCString()};path=/;domain=${domain}`;
  }
}
// 获取设置cookie的domain（和后端设置逻辑保持统一）
// 适配多域名，设置 cookie 到一级域名
function getParseDomain(beforeDomain) {
  let hostname = location.hostname.toLocaleLowerCase();
  // 获取一级域名
  const arr = hostname.split(".");
  hostname = arr.length > (hostname.includes(".com.cn") ? 3 : 2) ? arr.slice(1).join(".") : hostname;
  let domain = beforeDomain || hostname;
  const reLocalhost = /^(192.168.)|^(127.0.0.)/;
  if (reLocalhost.test(domain)) {
    // domain = domain;
  } else if (domain === "localhost") {
    domain = hostname;
  } else {
    domain = `.${domain}`;
  }
  return domain;
}

// 验证字符串str是否为日期格式的字符串
function isDate(str) {
  const reg = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
  if (!str) return false;
  if (reg.test(str) && RegExp.$2 <= 12 && RegExp.$3 <= 31 && RegExp.$4 <= 23 && RegExp.$5 <= 59 && RegExp.$6 <= 59) {
    return true;
  }
  return false;
}

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/select.css");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/input");

/***/ })

/******/ })["default"];